<div
  #menu
  class="menu-wrapper menu-wrapper-animation"
>
<!--
  <a [routerLink]="[basePath, 'contacteaza-ne']">
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="promo-container"
    >
      <h2
        class="title blink"
      >
        {{ 'promo_top' | translate }}
      </h2>
    </div>
  </a>
-->

  <div
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutAlign="start start"
    fxLayoutAlign.gt-sm="space-between center"
    class="menu-container menu-container-animation"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="menu-header menu-header-animation"
    >
      <a
        fxHide
        fxShow.gt-sm
        [routerLink]="[basePath]"
        class="logo-container logo-container-animation"
      >
        <img
          src="/assets/icons/logo.svg"
          alt="logo"
          class="logo logo-animation"
        >
      </a>
      <button
        class="main-menu-burger"
        fxHide.gt-sm
        [class.open]="open"
        (click)="toggleMobileMenu()"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </button>
      <a
        fxHide.gt-sm
        href="tel:{{ agencyService.agency.phone }}"
        class="main-phone"
      >
        {{ agencyService.agency.phone | beautify }}
      </a>
    </div>
    <div
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="start start"
      fxLayoutAlign.gt-sm="space-between center"
      class="menu-items-container menu-items-container-animation"
      [class.open]="open"
    >
      <nav
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutAlign="start start"
        fxLayoutAlign.gt-sm="center center"
        class="menu-items-wrapper menu-items-wrapper-animation"
      >
        <div
          *ngFor="let item of links"
          class="menu-item-wrapper menu-item-wrapper-animation"
        >
          <app-menu-item
            [item]="item"
            [children]="item.children"
            [currentRoute]="currentRoute"
            (toggleMobileMenu)="toggleMobileMenu()"
          >
          </app-menu-item>
        </div>
        <a
          href="tel:{{ agencyService.agency.phone }}"
          class="main-phone"
        >
          {{ agencyService.agency.phone | beautify }}
        </a>
      </nav>
      <a
        *ngIf="translate.currentLang == 'ro'"
        (click)="translate.use('en')"
        [attr.href]="localeService.getLocaleUrl('en')"
      >
        <img
          src="assets/icons/i18n/en.svg"
          alt="en"
          class="lang-icon"
        >
      </a>
      <a
        *ngIf="translate.currentLang == 'en'"
        (click)="translate.use('ro')"
        [attr.href]="localeService.getLocaleUrl('ro')"
      >
        <img
          src="assets/icons/i18n/ro.svg"
          alt="ro"
          class="lang-icon"
        >
      </a>
      <a
        fxLayout="row"
        fxLayoutAlign="center center"
        href="http://www.cpm.co.il"
        rel="nofollow"
        target="_blank"
      >
        <img
          src="/assets/icons/cpm.svg"
          alt="cpm"
          class="partner-logo"
        >
      </a>
      <!-- <ng-template
        [ngIf]="agencyService.agency.social_header_visibility === true && hasSocialLinks"
      >
        <app-social-icons-base
          [isTooltipBelow]="true"
        >
        </app-social-icons-base>
      </ng-template> -->
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/menu/menu-container/menu-container.component.html